import { CalendarMonthOutlined } from '@mui/icons-material';
import { ActionLogsIcon } from 'src/icons/navigation-icons/action-logs-icon';
import { BookingRulesIcon } from 'src/icons/navigation-icons/booking-rules-icon';
import { BookingsIcon } from 'src/icons/navigation-icons/bookings-icon';
import { EmployeesIcon } from 'src/icons/navigation-icons/employees-icon';
import { OrganizationDetailsIcon } from 'src/icons/navigation-icons/organization-details-icon';
import { PasswordIcon } from 'src/icons/navigation-icons/password-icon';
import { SpacesIcon } from 'src/icons/navigation-icons/spaces-icon';
import { StatisticsIcon } from 'src/icons/navigation-icons/statistics-icon';
import type { AppAbility } from 'src/permissions/define-permissions';
import { RouteTitle, SidebarRouteTitle } from 'src/types/enum/route-title';
import { RoutesGroup } from 'src/types/interfaces/routes-group';

export const getRoutes = (permissions: AppAbility): RoutesGroup[] => [
  {
    title: SidebarRouteTitle.SETUP,
    routes: [
      {
        icon: EmployeesIcon,
        title: RouteTitle.EMPLOYEES,
        href: '/tenant/employees',
        baseHref: '/tenant/employees',
        id: 'employees_navigation_link',
      },
      {
        icon: BookingRulesIcon,
        title: RouteTitle.BOOKING_RULES,
        href: '/tenant/booking-rules',
        baseHref: '/tenant/booking-rules',
        id: 'booking_rules_navigation_link',
      },
      {
        icon: SpacesIcon,
        title: RouteTitle.SPACES,
        href: '/tenant/spaces',
        baseHref: '/tenant/spaces',
        id: 'spaces',
      },
    ],
  },
  {
    title: SidebarRouteTitle.DATA_AND_ISSUES,
    routes: [
      {
        icon: StatisticsIcon,
        title: RouteTitle.STATISTICS,
        href: '/tenant/statistics',
        baseHref: '/tenant/statistics',
        id: 'statistics_navigation_link',
      },
      {
        icon: BookingsIcon,
        title: RouteTitle.BOOKINGS,
        href: '/tenant/bookings',
        baseHref: '/tenant/bookings',
        id: 'bookings_navigation_link',
      },
      // TODO: temporary hide the issues route, because it is not implemented yet
      // {
      //   icon: IssuesIcon,
      //   title: RouteTitle.ISSUES,
      //   href: '/tenant/issues',
      //   baseHref: '/tenant/issues',
      //   id: 'issues_navigation_link',
      // },
    ],
  },
  {
    title: SidebarRouteTitle.SUPPORT_AND_SETTINGS,
    routes: [
      ...(permissions.can('read', 'CalendarIntegration')
        ? [
            {
              icon: CalendarMonthOutlined,
              title: RouteTitle.CALENDAR_INTEGRATION,
              href: '/tenant/calendar-integration',
              baseHref: '/tenant/calendar-integration',
              id: 'calendar-integration_navigation_link',
            },
          ]
        : []),
      {
        icon: OrganizationDetailsIcon,
        title: RouteTitle.ORGANIZATION_DETAILS,
        href: '/tenant/organization-details',
        baseHref: '/tenant/organization-details',
        id: 'organization-details_navigation_link',
      },
      {
        icon: ActionLogsIcon,
        title: RouteTitle.AUDIT_LOGS,
        href: '/tenant/audit-logs',
        baseHref: '/tenant/audit-logs',
        id: 'tenant-audit-logs_navigation_link',
      },
      {
        icon: PasswordIcon,
        title: RouteTitle.PASSWORD,
        href: '/tenant/password',
        baseHref: '/tenant/password',
        id: 'password_navigation_link',
      },
    ],
  },
];
